import { parseNumberList } from "@/lib/parse-number";

export interface XYPoint {
  x: number;
  y: number;
}

export interface ParsedPoints {
  points: XYPoint[];
  /** 1-based numbers of non-blank lines that were not exactly two numbers. */
  badLines: number[];
}

/**
 * One "x, y" pair per line (comma, semicolon, space or tab between the numbers; a
 * decimal comma is read when the line uses a semicolon). Blank lines are ignored.
 */
export function parseXYPairs(text: string): ParsedPoints {
  const points: XYPoint[] = [];
  const badLines: number[] = [];
  text.split("\n").forEach((line, index) => {
    if (line.trim() === "") {
      return;
    }
    const values = parseNumberList(line);
    if (values.length === 2) {
      points.push({ x: values[0], y: values[1] });
    } else {
      badLines.push(index + 1);
    }
  });
  return { points, badLines };
}
